import NewRequest from "../components/Profile/NewRequest";

const ThemePage = () => {
    return (
        <NewRequest />
    )
}

export default ThemePage